import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {CentreListPage} from "./CentreListPage";
import {CentreAddPage} from "./CentreAddPage";
import {CentreEditPage} from "./CentreEditPage";

const CentreWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>

        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Centres</PageTitle>
              <CentreListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Centres', path: '/centres', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <CentreAddPage />
            </>
          }
        />
        <Route
          path=':centreId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Centres', path: '/centres', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <CentreEditPage />
            </>
          }
        />
        <Route index element={<Navigate to='/centres/liste' />} />
      </Routes>
    </>
  )
}

export {CentreWrapper}
